export default class AnalyticsAverageOrderProductQuantity {
    averageOrderProductQuantity = 0;
}